import Trash from '@/social/post/trash/TrashedPosts.vue';
import AdminLayout from '../layout/AdminLayout.vue';
import Users from '../Users.vue';
import Customers from '../Customers.vue';
import Clients from '../Clients.vue';
import Client from '../Client.vue';
import Billing from '../Billing.vue';
import Integrations from '../Integrations.vue';

export default [
  {
    path: '/admin/accounts/:accountId',
    component: AdminLayout,
    props: true,
    children: [
      {
        path: 'users',
        component: Users,
        props: true,
      },
      {
        path: 'customers',
        component: Customers,
      },
      {
        path: 'clients',
        component: Clients,
        props: true,
      },
      {
        path: 'clients/:clientId',
        component: Client,
        props: true,
      },
      {
        path: 'billing',
        component: Billing,
        props: true,
      },
      {
        path: 'trash',
        component: Trash,
        props: true,
      },
      {
        path: 'integrations',
        component: Integrations,
        props: true,
      },
    ],
  },
];
